import axios from 'axios';

export const processAndSendOrder = async (tempPostObj, baseURLPrice) => {
  const hasRequiredFields =
    tempPostObj?.SewingOrderDetails?.[0]?.FabricId !== undefined &&
    tempPostObj?.PreorderText !== undefined;

  if (!hasRequiredFields) return false;

  const isModel0325 = tempPostObj.SewingModelId === '0325';

  // ========== تبدیل ساختار فقط برای مدل 0325 ==========
  let finalPayload = tempPostObj;

  if (isModel0325) {
    // 1. ادغام فیلدهای سطح اصلی با PreorderText (اولویت با PreorderText)
    const { PreorderText, SewingOrderDetails, ...rest } = tempPostObj;
    const flatObject = { ...rest, ...PreorderText };

    // 2. ساخت آیتم دوم از روی آیتم اول
    const originalItem = SewingOrderDetails[0];
    const secondItem = JSON.parse(JSON.stringify(originalItem));

    // تغییرات آیتم دوم
    secondItem.CurtainPartId = 2302;
    delete secondItem.LiningId;        // حذف LiningId
    delete secondItem.fabricItemId;    // حذف fabricItemId
    secondItem.Accessories = [];       // خالی کردن Accessories

    // 3. ساخت آرایه جدید SewingOrderDetails
    const newSewingDetails = [originalItem, secondItem];

    // 4. ساخت payload نهایی بدون PreorderText
    finalPayload = {
      ...flatObject,
      SewingOrderDetails: newSewingDetails,
    };

    // حذف PreorderText (اگر هنوز وجود داشته باشد)
   // delete finalPayload.PreorderText;
  }

  // ========== پردازش مشترک (برای هر دو مدل) ==========
 
  if (!finalPayload.SewingOrderDetails[0]) finalPayload.SewingOrderDetails[0] = {};

  const is0325 = isModel0325; // true/false

  // MotorType
  if (finalPayload.MotorType && finalPayload.MotorType !== '') {
    const motorProductId =
      finalPayload.MotorType === 'Standard'
        ? '61500508'
        : finalPayload.MotorType === 'Smart'
        ? '61500517'
        : null;

    finalPayload.SewingOrderDetails[0].ControlType = 'false';
    finalPayload.SewingOrderDetails[0].MotorProductId = motorProductId;

    if (is0325 && finalPayload.SewingOrderDetails[1]) {
      finalPayload.SewingOrderDetails[1].ControlType = 'false';
      finalPayload.SewingOrderDetails[1].MotorProductId = motorProductId;
    }
  }

  // ChainLength
  if (finalPayload.ChainLength && finalPayload.ChainLength !== '') {
    let chainId = null;
    if (finalPayload.ChainLength === '300') chainId = '90908901';
    else if (finalPayload.ChainLength === '500') chainId = '90908902';
    else if (finalPayload.ChainLength === '200') chainId = '90908903';
    else if (finalPayload.ChainLength === '250') chainId = '90908904';
    finalPayload.SewingOrderDetails[0].ControlType = 'true';
    finalPayload.SewingOrderDetails[0].ChainId = chainId;

    if (is0325 && finalPayload.SewingOrderDetails[1]) {
      finalPayload.SewingOrderDetails[1].ControlType = 'true';
      finalPayload.SewingOrderDetails[1].ChainId = chainId;
    }
  }

  // Headrail
  if (finalPayload.Headrail && finalPayload.Headrail !== '') {
    let headRailId = null;
    if (finalPayload.Headrail === 'Upholstered') headRailId = '900004';
    else if (finalPayload.Headrail === 'MetalValance') headRailId = '900005';
    else if (finalPayload.Headrail === 'MetalValanceFabricInsert') headRailId = '900006';

    finalPayload.SewingOrderDetails[0].HeadRailId = headRailId;
    if (is0325 && finalPayload.SewingOrderDetails[1]) {
      finalPayload.SewingOrderDetails[1].HeadRailId = headRailId;
    }
  }

  // HemStyle
  if (finalPayload.HemStyle && finalPayload.HemStyle !== '') {
    let hemStyleId = null;
    if (finalPayload.HemStyle === 'Scallop') hemStyleId = '900001';
    else if (finalPayload.HemStyle === 'Wave') hemStyleId = '900002';
    else if (finalPayload.HemStyle === 'Traditional') hemStyleId = '900003';

    finalPayload.SewingOrderDetails[0].HemStyleId = hemStyleId;
    if (is0325 && finalPayload.SewingOrderDetails[1]) {
      finalPayload.SewingOrderDetails[1].HemStyleId = hemStyleId;
    }
  }

  // BottomBarStyle
  if (finalPayload.BottomBarStyle && finalPayload.BottomBarStyle !== '') {
    let bottomBarId =
      finalPayload.BottomBarStyle === 'Decorative Metal Bar' ? '900007' : null;

    finalPayload.SewingOrderDetails[0].BottomBarId = bottomBarId;
    if (is0325 && finalPayload.SewingOrderDetails[1]) {
      finalPayload.SewingOrderDetails[1].BottomBarId = bottomBarId;
    }
  }

 

  // ارسال درخواست
  try {
    const response = await axios.post(baseURLPrice, finalPayload);
    return response;
  } catch (err) {
    console.error(err);
    return false;
  }
};